<template>
  <div class="membership-actions" :class="{ 'membership-actions--single': !showHealthcare }" role="group" aria-label="Abo verwalten">
    <button type="button" class="membership-actions__button" @click="$emit('pause')">
      <v-icon size="24" aria-hidden="true">mdi-pause-circle-outline</v-icon>
      <span>Abo pausieren</span>
    </button>
    <button v-if="showHealthcare" type="button" class="membership-actions__button" aria-label="KK-Bestätigung (Krankenkassenbestätigung)" title="Krankenkassenbestätigung" @click="$emit('healthcare')">
      <v-icon size="24" aria-hidden="true">mdi-shield-check-outline</v-icon>
      <span>KK-Bestätigung</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "CustomerHubMembershipActions",
  props: { showHealthcare: Boolean },
}
</script>

<style scoped>
.membership-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 20px;
}
.membership-actions__button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  min-height: 88px;
  padding: 16px 10px;
  border: 0;
  border-radius: 14px;
  background: #383838;
  box-shadow: inset 0 1px 0 #ffffff0d, 0 3px 8px #00000033;
  color: #f7f7f7;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  cursor: pointer;
}
.membership-actions__button > span { min-width: 0; overflow-wrap: anywhere; }
.membership-actions__button .v-icon { flex: 0 0 auto; color: var(--v-primary-base, #00963f); }
.membership-actions__button:focus-visible { outline: 2px solid #f7f7f7; outline-offset: 3px; }
.membership-actions--single { grid-template-columns: minmax(0, 1fr); }
.membership-actions--single .membership-actions__button { flex-direction: row; min-height: 60px; gap: 10px; }
@media (hover: hover) {
  .membership-actions__button:hover { background: #444444; }
}
.membership-actions__button:active { background: #303030; box-shadow: inset 0 2px 4px #00000040; }
@media (max-width: 360px) {
  .membership-actions { gap: 8px; }
  .membership-actions__button { padding: 14px 8px; }
}
</style>
